import { useTranslation } from 'react-i18next';

import { KeyValueTable } from '@/components/organisms/DataTable';
import type { Connection } from '@/domain/bioscopes';
import { formatDateTimeWorded } from '@/utils/date';

import styles from './BioscopeConnection.module.scss';

interface BioscopeConnectionProps {
    title?: string;
    connection: Connection;
}

function BioscopeConnection({
    title = 'molecules.bioscopeConnection.connection',
    connection,
}: BioscopeConnectionProps) {
    const { t } = useTranslation();

    return (
        <div className={styles.BioscopeConnection}>
            <h2>{t(title)}</h2>
            <div className={styles.section}>
                <KeyValueTable
                    tableClassName={styles.nowrapTable}
                    rows={[
                        {
                            key: 'connection',
                            label: t('molecules.bioscopeConnection.connection'),
                            value: connection
                                ? formatDateTimeWorded(connection.lastSeen, 'minute')
                                : t('molecules.common.neverUpdated'),
                        },
                        ...(connection
                            ? [
                                  {
                                      key: 'cabinet',
                                      label: t('molecules.bioscopeConnection.cabinet'),
                                      value: connection.cabinet
                                          ? connection.cabinet
                                          : t('molecules.bioscopeConnection.unknown'),
                                  },
                                  {
                                      key: 'ip',
                                      label: 'IP',
                                      value: connection.ip
                                          ? connection.ip
                                          : t('molecules.bioscopeConnection.unknown'),
                                  },
                                  ...(connection.phoneNumber
                                      ? [
                                            {
                                                key: 'phoneNumber',
                                                label: t(
                                                    'molecules.bioscopeConnection.phoneNumber'
                                                ),
                                                value: connection.phoneNumber,
                                            },
                                        ]
                                      : []),
                                  ...(connection.router
                                      ? [
                                            {
                                                key: 'router',
                                                label: t('bioscopeDetail.connection.router'),
                                                value: connection.router,
                                            },
                                        ]
                                      : []),
                                  ...(connection.internetSource
                                      ? [
                                            {
                                                key: 'internetSource',
                                                label: t(
                                                    'molecules.bioscopeConnection.internetSource'
                                                ),
                                                value: connection.internetSource,
                                            },
                                        ]
                                      : []),
                                  ...(connection.wanIp
                                      ? [
                                            {
                                                key: 'wanIp',
                                                label: t('molecules.bioscopeConnection.wanIp'),
                                                value: connection.wanIp,
                                            },
                                        ]
                                      : []),
                              ]
                            : []),
                    ]}
                />
            </div>
        </div>
    );
}

export default BioscopeConnection;
export { BioscopeConnection };
